export const collapseBtnLabel = $localize`:OrderBook|Collapse all order details@@orderBookCollapseAll:Collapse All`;
export const expandBtnLabel = $localize`:OrderBook|Expand all order details@@orderBookExpandAll:Expand All`;
